var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "email-a",
    d: "M20.0000859,3 C21.6523706,3 23.0000859,4.34771525 23.0000859,6 L23.0000859,18 C23.0000859,19.6522847 21.6523706,21 20.0000859,21 L4.00008586,21 C2.34780111,21 1.00008586,19.6522847 1.00008586,18 L1.00008586,6 C1.00008586,4.34771525 2.34780111,3 4.00008586,3 L20.0000859,3 Z M21,7.92 L12.5735482,13.8192319 C12.2292281,14.060256 11.7709437,14.060256 11.4266235,13.8192319 L11.4266235,13.8192319 L3,7.921 L3.00008586,18 C3.00008586,18.5477153 3.45237061,19 4.00008586,19 L20.0000859,19 C20.5478011,19 21.0000859,18.5477153 21.0000859,18 L21,7.92 Z M20.0000859,5 L4.00008586,5 C3.61208728,5 3.27197793,5.22696691 3.10661548,5.55404305 L12.0000859,11.7793444 L20.8935562,5.55404305 C20.7281938,5.22696691 20.3880844,5 20.0000859,5 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "email-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#email-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#email-a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#email-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.298aa821904188f4a8fe9c1ce09df277.svg";
export { ForwardRef as ReactComponent };